import React from 'react';
import { WALLET } from '@blink/components/src/types';
import { ReactComponent as MetamaskIcon } from '@blink/assets/src/icons/metamask.svg';
import { ReactComponent as CoinbaseIcon } from '@blink/assets/src/icons/coinbase.svg';
import { ReactComponent as RabbyIcon } from '@blink/assets/src/icons/rabby.svg';
import { ReactComponent as WalletConnectIcon } from '@blink/assets/src/icons/walletConnect.svg';

export const walletIconMap = new Map()
    .set(WALLET.META_MASK, (className: string) => <MetamaskIcon className={className} />)
    .set(WALLET.RABBY, (className: string) => <RabbyIcon className={className} />)
    .set(WALLET.COIN_BASE, (className: string) => <CoinbaseIcon className={className} />)
    .set(WALLET.WALLET_CONNECT, (className: string) => <WalletConnectIcon className={className} />);

export type WalletIconProps = {
    walletType: WALLET;
};

interface WalletIconComponent extends React.FC<WalletIconProps> {
    types: typeof WALLET;
}

const WalletIcon: WalletIconComponent = ({ walletType }) => {
    const className = 'w-9 h-9';
    return walletIconMap.has(walletType) ? walletIconMap.get(walletType)(className) : null;
};

WalletIcon.types = WALLET;

export { WalletIcon };
